import { useEffect } from "react";
import { watchSession } from "../api.ts";
import { onBecameVisible } from "./build-refresh.ts";

/** How often a visible tab asks whether its session still lives (a revocation elsewhere). */
export const sessionWatch = { pollMs: 30_000 };

/**
 * Checks the session every 30 s while the tab is visible, and when it becomes visible again: a
 * sign-out on another device, or in this browser without BroadcastChannel, shows up here. The
 * same check tells of a new build (build-refresh.ts). Only becoming visible is a safe point to
 * reload: the poll never reloads a tab someone may be reading.
 */
export function useSessionWatch(): void {
  useEffect(() => {
    const visible = () => document.visibilityState !== "hidden";
    const timer = setInterval(() => {
      if (visible()) {
        void watchSession();
      }
    }, sessionWatch.pollMs);
    const onVisible = () => {
      if (visible()) {
        void watchSession().then(onBecameVisible);
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
}
